import thumbnailImg from 'Static/thumbnails/screenshot--space.png';

export default {
  slug: 'space',
  title: 'Space',
  seriesNumber: '8',
  published: true,
  thumbnailImg,
  subject: 'Earth Science',
  graphicFileName: 'Image_Space.png',
  graphicAlt: 'App screenshot of Space depicting a planet’s rings',
  iconFileName: 'Icon_Space.png',
  iconLargeFileName: 'Icon_Space@2x.png',
  iconAlt: 'App icon for Space depicting a planet and two comets',
  description:
    'Topics covered include space, solar system, moon phases, distance, mass, scale, temperature, planets, orbits, day, night, seasons, and years.',
  briefDescription: 'Learn about our solar system.',
  supportedLanguages: [
    'en',
    'af',
    'ar',
    'bg',
    'bn',
    'ca',
    'cs',
    'da',
    'de',
    'el',
    'es',
    'fa',
    'fi',
    'fl',
    'fr',
    'he',
    'hi',
    'ht',
    'hu',
    'id',
    'is',
    'it',
    'ja',
    'ko',
    'ms',
    'nb',
    'nl',
    'pl',
    'pt',
    'ru',
    'sk',
    'sr',
    'sv',
    'th',
    'tl',
    'tr',
    'uk',
    'ur',
    'vi',
    'zh-Hans',
    'zh-Hant',
  ],
  scenes: [
    'Intro',
    'Orbit',
    'Scale',
    'Distance',
    'Mass',
    'Sun',
    'Sun_SliderOpen',
    'Scene_Sun',
    'Mercury',
    'Mercury_SliderOpen',
    'Scene_Mercury',
    'Venus',
    'Venus_SliderOpen',
    'Scene_Venus',
    'Earth',
    'Earth_SliderOpen',
    'Scene_Moon',
    'Mars',
    'Mars_SliderOpen',
    'Scene_Mars',
    'Jupiter',
    'Jupiter_SliderOpen',
    'Scene_Jupiter',
    'Saturn',
    'Saturn_SliderOpen',
    'Scene_Saturn_Ring',
    'Uranus',
    'Uranus_SliderOpen',
    'Scene_Uranus',
    'Neptune',
    'Neptune_SliderOpen',
    'Scene_Neptune',
  ],
  featuredPrintables: ['space_comparing_planets'],
  printables: ['space_visit', 'concept_map', 'generating_questions'],
  topics: [
    'classifying_planets',
    'inner_planets',
    'outer_planets',
    'observations_technology',
  ],
  appLinks: {
    appStoreLink: 'https://apps.apple.com/us/app/space-by-tinybop/id1126517945',
  },
};
